import { __extends } from "tslib";
import { AbstractionBase, UUID } from '@awayjs/core';
import { RenderableEvent } from '../events/RenderableEvent';
/**
 * @class away.pool.RenderEntity
 */
var RenderEntity = /** @class */ (function (_super) {
    __extends(RenderEntity, _super);
    /**
     * //TODO
     *
     * @param materialClassGL
     */
    function RenderEntity(entity, renderer) {
        var _this = _super.call(this, entity, renderer) || this;
        // private _abstractionPool: Object = new Object();
        _this._renderables = [];
        _this.id = UUID.Next();
        _this.node = entity.parent;
        _this.stage = renderer.stage;
        _this._onInvalidateElementsDelegate = function (event) { return _this._onInvalidateElements(event); };
        _this._onInvalidateMaterialDelegate = function (event) { return _this._onInvalidateMaterial(event); };
        _this._onInvalidateStyleDelegate = function (event) { return _this._onInvalidateStyle(event); };
        _this.node.container.addEventListener(RenderableEvent.INVALIDATE_ELEMENTS, _this._onInvalidateElementsDelegate);
        _this.node.container.addEventListener(RenderableEvent.INVALIDATE_MATERIAL, _this._onInvalidateMaterialDelegate);
        _this.node.container.addEventListener(RenderableEvent.INVALIDATE_STYLE, _this._onInvalidateStyleDelegate);
        return _this;
    }
    RenderEntity.prototype.onClear = function (event) {
        this.node.container.removeEventListener(RenderableEvent.INVALIDATE_ELEMENTS, this._onInvalidateElementsDelegate);
        this.node.container.removeEventListener(RenderableEvent.INVALIDATE_MATERIAL, this._onInvalidateMaterialDelegate);
        this.node.container.removeEventListener(RenderableEvent.INVALIDATE_STYLE, this._onInvalidateStyleDelegate);
        for (var i = this._renderables.length - 1; i >= 0; i--)
            this._renderables[i].onClear(event);
        _super.prototype.onClear.call(this, event);
    };
    RenderEntity.prototype.addRenderable = function (renderable) {
        this._renderables.push(renderable);
    };
    RenderEntity.prototype.removeRenderable = function (renderable) {
        this._renderables.splice(this._renderables.indexOf(renderable), 1);
    };
    RenderEntity.prototype._onInvalidateElements = function (event) {
        // for (const key in this._abstractionPool)
        // 	(this._abstractionPool[key] as _Render_RenderableBase)._onInvalidateElements();
    };
    RenderEntity.prototype._onInvalidateMaterial = function (event) {
        // for (const key in this._abstractionPool)
        // 	(this._abstractionPool[key] as _Render_RenderableBase)._onInvalidateMaterial();
    };
    RenderEntity.prototype._onInvalidateStyle = function (event) {
        // for (const key in this._abstractionPool)
        // 	(this._abstractionPool[key] as _Render_RenderableBase)._onInvalidateStyle();
    };
    RenderEntity.prototype.requestAbstraction = function (asset) {
        return RenderEntity._renderRenderableClassPool[asset.assetType];
    };
    /**
     *
     * @param imageObjectClass
     */
    RenderEntity.registerRenderable = function (renderStateClass, assetClass) {
        RenderEntity._renderRenderableClassPool[assetClass.assetType] = renderStateClass;
    };
    RenderEntity._renderRenderableClassPool = new Object();
    return RenderEntity;
}(AbstractionBase));
export { RenderEntity };
